import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import * as auth from "../actions/auth";
import {ROUTER_USER_LOGIN} from "../constants/routers";


export default function(Page) {
  class Authorize extends React.Component {

    static propTypes = {
      isAuthenticated: PropTypes.bool.isRequired
    };

    componentWillMount() {
      if (!this.props.isAuthenticated) {
        this.props.history.replace(ROUTER_USER_LOGIN);
      }
    }

    componentWillUpdate(nextProps) {
      if (!nextProps.isAuthenticated) {
        this.props.history.replace(ROUTER_USER_LOGIN);
      }
    }

    render() {
      return <Page {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    return {
      ...state,
      isAuthenticated: auth.is()
    };
  };

  return withRouter(connect(mapStateToProps)(Authorize));
}
